module.exports = __webpack_public_path__ + "img/difficultylevel.16e869f4.svg";